import { Icon } from '@acpaas-ui/react-components';
import { useRef, useState } from 'react';
import { useOutsideClick } from '../../hooks/useOutsideClick.hook';
import Flyout from './Flyout';

const ActionsFlyout = ({ label = 'Acties', actions = [], onActionClick }) => {
  const shareContentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { elRef } = useOutsideClick((clickedEl) => {
    if (clickedEl !== shareContentRef.current && !shareContentRef.current?.contains(clickedEl)) {
      setIsOpen(false);
    }
  });

  return (
    <div className="spo-m-actions-flyout u-relative u-inline-block">
      <button ref={elRef} className="has-icon-right a-button-outline" onClick={() => setIsOpen(!isOpen)}>
        <Icon name={`ai-arrow-${isOpen ? 'up' : 'down'}-1`} />
        {label}
      </button>
      <Flyout rootElement={elRef.current} isOpen={isOpen} direction="up" size="sm">
        <ul ref={shareContentRef} className="m-selectable-list">
          {actions?.map((action) => (
            <li
              key={action.name}
              className="m-selectable-list__item"
              onClick={() => onActionClick(action.name, setIsOpen)}
            >
              {action.element}
            </li>
          ))}
        </ul>
      </Flyout>
    </div>
  );
};

export default ActionsFlyout;
